import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Container, Button, Alert, Badge
} from 'reactstrap';
import HttpClient from '../myapi';

class ConfirmDelMd extends React.Component {
    state = {
        processing: false, success: false, failed: false
    }
    delProd = () => {
        this.setState({ processing: true });

        HttpClient.post('/delProd.php', { iid: this.props.img.id })
            .then(res => {
                if (res === '*') {
                    this.setState({ success: true })
                } else {
                    this.setState({ failed: true })
                }
            })
    }
    onDelete = () => {
        this.props.onsuccess();
    }
    render() {
        return (
            <Modal isOpen={true} toggle={this.toggle}>
                <ModalHeader>Confirm Delete</ModalHeader>
                <ModalBody>
                    <Container fluid>
                        {
                            this.state.success &&
                            <Alert color="success">
                                Product Deleted Successfully !
                            </Alert>
                        }
                        {
                            !this.state.success &&
                            <Alert color="danger">
                                Are you sure to Delete Product: #{this.props.img.id}
                            </Alert>
                        }
                    </Container>
                </ModalBody>
                <ModalFooter>
                    {
                        this.state.failed && 
                    <Badge color="danger">Process Failed</Badge>
                    }
                    {
                        !this.state.success &&
                        <div>
                            <Button
                                color="danger"
                                size="sm"
                                onClick={this.delProd}
                                disabled={this.state.processing}
                            >
                                Yes
                            </Button>{' '}
                            <Button size="sm"
                                color="dark"
                                outline
                                onClick={this.props.closeDel}>
                                No
                    </Button>
                        </div>
                    }
                    {
                        this.state.success &&
                        <Button size="sm"
                            color="success"
                            onClick={this.onDelete}
                        >Okay
                        </Button>
                    }
                </ModalFooter>
            </Modal>
        );
    }
}
export default ConfirmDelMd;


// WEBPACK FOOTER //
// ./src/admin/ConfirmDelMd.jsx